export default __webpack_public_path__ + "static/media/icon-silo-capacity.b0dfe909.svg";